import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import PageAddBreed from '../../pages/Breeds/Add';

const ModalAddBreed = props => {
  const { handleModalClose, showModal } = props;

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={showModal}
        onHide={handleModalClose}
        animation={true}
      >
        <Modal.Body>
          <PageAddBreed handleModalClose={handleModalClose} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalAddBreed.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool
};

export default ModalAddBreed;
